import { render, staticRenderFns } from "./DrivingLicenseDetail.vue?vue&type=template&id=748444b8&"
import script from "./DrivingLicenseDetail.vue?vue&type=script&lang=js&"
export * from "./DrivingLicenseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports